import { aiEditPrompts } from "../../../prompts";
import type { EditIntensity } from "../types";

interface BuildEditPromptContentArgs {
  originalText: string;
  activePrompt: string;
  selectedTone: string;
  selectedStyleGuide: string;
  surroundingContext: string;
  editIntensity: EditIntensity;
}

export const buildEditPromptContent = ({
  originalText,
  activePrompt,
  selectedTone,
  selectedStyleGuide,
  surroundingContext,
  editIntensity,
}: BuildEditPromptContentArgs): string => {
  if (selectedStyleGuide && aiEditPrompts.styleGuideTemplate) {
    return aiEditPrompts.styleGuideTemplate(originalText, selectedStyleGuide);
  }

  if (!selectedTone && aiEditPrompts.multiLevelEditTemplate) {
    return aiEditPrompts.multiLevelEditTemplate(
      originalText,
      activePrompt,
      editIntensity
    );
  }

  return aiEditPrompts.editRequestTemplate(
    originalText,
    activePrompt,
    selectedTone || undefined,
    surroundingContext || undefined,
    editIntensity
  );
};
